import { AccountsContext } from '../../components/context/account-context';
import { getAllAds } from '../../services/ads-service';
import React, { useContext, useEffect, useState } from 'react'
import FileGrid from './file-grid';
import { useOutletContext } from 'react-router-dom';
import Heading from '../../components/shared/heading';
import Loader from '../../components/shared/loader';
import Help from './help';
import { usePageHelp } from '../../components/context/help-context';

const Ads = () => {
    usePageHelp(Help);
    const { accountId } = useContext(AccountsContext);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { collapsed } = useOutletContext();

    const fetchAds = async () => {
        setLoading(true);
        try {
            const response = await getAllAds(accountId);
            console.log(response)

            if (response.success) {
                const sortedData = response.data.data.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)); // sort latest first
                setData(sortedData);
                setError(null);
            } else {
                setError(response.data.message || 'Failed to fetch ads records');
            }
        } catch (err) {
            setError('An error occurred while fetching ads records');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAds();
    }, [accountId]);

    return (
        <div className="px-6 py-4">
            <div className='mb-2'>
                <Heading>Offers</Heading>
            </div>

            {error && (
                <div className="text-red-600 bg-red-100 px-4 py-2 rounded-md">
                    {error}
                </div>
            )}

            {loading ? (
                <Loader />
            ) : (
                <FileGrid
                    files={data}
                    collapsed={collapsed}
                />
            )
            }
        </div>
    )
}

export default Ads
